/**
 * Module to manage cookies in the site.
 * 
 * The main difference of this cookieManager between legacies files in GlobalResources14 is that
 * those older modules should only be used on pages that use vanillaJS and requireJS for module loading.
 */
const partnerIdElement = document.querySelector('[data-cookie-partner]');

function getCookieName(name, isPartnerCookie) {
  if (isPartnerCookie && partnerIdElement) {
    return `${name}_${partnerIdElement.value}`
  }
  return name;
}

/**
  * @public
  * readCookie: searches for a cookie and returns its value.
  *
  * @param {string} name of the cookie to be retrieved.
  * @param {boolean} isPartnerCookie true if the cookie name should include the partner ID information,
  * otherwise false.
  */
function readCookie(name, isPartnerCookie) {
  let cookieName = getCookieName(name, isPartnerCookie);
  cookieName += '=';

  const items = document.cookie.split(';') || [];
  const nameLength = cookieName.length;
  const cookieFound = items.find((item) => {
    if (item.trim().indexOf(cookieName) === 0) {
      return item;
    }
    return null;
  });

  if (!cookieFound) {
    return null;
  }

  return cookieFound.trim().substring(nameLength);
}

/**
   * @public
   * createCookieByMins: creates a new cookie for the domain, expering in minutes.
   *
   * @param {string} name of the cookie.
   * @param {any} value that will be stored in the cookie.
   * @param {number} minutes of expiration time for the cookie.
   * @param {boolean} isPartnerCookie true if the cookie name should include the partner ID information,
   * otherwise false.
   */
function createCookieByMins(name, value, mins, isPartnerCookie) {
  let expires = '';
  const cookieName = getCookieName(name, isPartnerCookie);

  if (mins) {
    const date = new Date();
    date.setTime(date.getTime() + (mins * 60 * 1000));
    expires = '; expires=' + date.toGMTString();
  }

  document.cookie = `${cookieName}=${value}${expires}; path=/; secure`;
}

export {
  readCookie,
  createCookieByMins
};
